import React, {useState} from "react";
import {DynamicComponentProps} from "../../../core/_models";
import {Button as MaterialButton} from "@mui/material";
import {axiosRaw} from "../../../../../helpers/axios";
import {Button, Modal} from "react-bootstrap";
import {PdfRendererComponent} from "../pdf-renderer/PdfRendererComponent";
import {PdfElementConfig} from "../pdf-renderer/_models";

interface Props extends DynamicComponentProps {
    row: any
}

export function PdfViewerGridButtonComponent({config, row}: Props) {
    const {hint, text, url, data: additionalData = []} = config;
    const [state, setState] = useState<{ html: PdfElementConfig[] | null }>({
        html: null
    });

    const replacePlaceholders = (jsonContent: PdfElementConfig[]): PdfElementConfig[] => {
        const replaced = [];
        for (const line of jsonContent) {
            if (line.content != null) {
                for (const key in row) {
                    line.content = line.content.replaceAll(`{{${key}}}`, row[key])
                }
                for (const add of additionalData) {
                    line.content = line.content.replaceAll(`{{${add.key}}}`, add.value)
                }
            }
            replaced.push(line)
        }
        return replaced
    }

    const loadUrl = () => {
        axiosRaw.get(url).then(({data: {data}}) => {
            setState({html: replacePlaceholders(data)})
        });
    }

    if (state.html != null) {
        return (
            <Modal show={true} onHide={() => setState({html: null})} size="lg">
                <Modal.Header closeButton>
                    <Modal.Title>PDF Renderer</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <PdfRendererComponent contents={state.html}/>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setState({html: null})}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>
        );
    }

    return (
        <MaterialButton variant="contained" className='mr-4' color="primary" title={hint} onClick={(e) => {
            loadUrl();
        }}>
            {text}
        </MaterialButton>
    )
}